export const getBannerSize = (cellsInRow: number) => {
    let x = 1;

    switch (cellsInRow) {
        case 1:
            x = 1;
            break;
        case 2:
            x = 2;
            break;
        case 3:
            x = 2;
            break;
        case 4:
            x = 2;
            break;
        case 5:
            x = 2;
            break;
        case 6:
            x = 2;
            break;
        case 7:
            x = 3;
            break;
        case 8:
            x = 3;
            break;
        default:
            break;
    }

    return x;
};
